import styled, { css } from 'styled-components';
/**
 * Wrapper for the actual check box and its label.
 *
 * @return {jsx}
 */

export var Wrapper = styled.div.withConfig({
  displayName: "elements__Wrapper",
  componentId: "d6yahn-0"
})(["display:flex;align-items:baseline;flex-direction:column;padding:0.6rem;", ";", ";"], function (_ref) {
  var isRow = _ref.isRow;
  return isRow && css(["flex-direction:row;"]);
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && css(["cursor:not-allowed;"]);
});